module.exports = __webpack_public_path__ + "static/media/carouselIcon.2a93a9f7.svg";